import { render, staticRenderFns } from "./AddDealersModal.vue?vue&type=template&id=bd11b6aa"
import script from "./AddDealersModal.vue?vue&type=script&lang=js"
export * from "./AddDealersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports